const de = {
  currency: {
    style: 'currency',
    currency: 'EUR',
  },
};

export default de;
